<template>
  <ProductBuyDetail>
    <template v-slot:icon>
      <span v-if="inStock" class="af af-checkmark"></span>
      <span v-else class="af af-about-small"></span>
    </template>
    <template v-slot:text>
      <div class="product-stock">
        <template v-if="product && product.status === 'AVAILABLE'">
          <div v-if="loading || !mounted" class="delivery-details delivery-details-loading skeleton">
            <div class="stock-status">
              <span class="stock-title transparent">&nbsp;</span>
            </div>
          </div>
          <div v-else-if="error">
            <div class="stock-status">
              <span class="stock-title">Stock status unknown</span>
            </div>
          </div>
          <div v-else-if="!inStock && !estimate.inStockIn" class="delivery-details">
            <div class="stock-status">
              <span class="stock-title">Out of stock</span>
            </div>
          </div>
          <div v-else class="delivery-details">
            <div class="stock-status">
              <span v-if="inStock" class="stock-title">In Stock</span>
              <span v-else class="stock-title" :hidden="!estimate.inStockIn">
                Back in stock{{ estimate.inStockIn ? ` in ${estimate.inStockIn}` : '' }}</span
              >
            </div>
          </div>
        </template>
      </div>
    </template>
  </ProductBuyDetail>
</template>

<script>
import ProductBuyDetail from '@/components/product/ProductBuyDetail.vue';

export default {
  name: 'ProductStock',
  components: {
    ProductBuyDetail,
  },

  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    error: {},
    product: {},
    estimate: {},
  },
  data() {
    return {
      mounted: false,
    };
  },
  computed: {
    inStock() {
      if (!this.estimate) {
        return false;
      }
      return this.estimate.productIsInStock;
    },
  },
  mounted() {
    this.mounted = true;
  },
};
</script>

<style lang="postcss" scoped>
@import '@/pixel/style/variables';
@import '@/pixel/style/mixins';

.product-stock {
  position: relative;

  .delivery-details {
    display: flex;
    justify-content: space-between;
  }

  .delivery-details-loading {
    width: 60px;
  }

  .free-shipping-container {
    margin-left: 12px;

    @media (max-width: calc($small-breakpoint - 1px)) {
      margin-left: 0px;
    }
  }

  .stock-status {
    display: flex;
    align-items: center;

    .stock-title {
      transition: opacity 100ms linear;

      &.transparent {
        opacity: 0;
      }
    }
  }
}
</style>
